import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import { Table } from 'src/components/complex';
import { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';

export const filteredTreatments = (treatments) => {
  return (treatments || [])
    .map((treatment) => {
      return {
        name: treatment.name || '',
        fee: parseFloat(treatment.fee) || 0
      };
    })
    .filter((treatment) => {
      return (
        typeof treatment.name === 'string' &&
        treatment.name.length > 2 &&
        treatment.name.length < 200 &&
        typeof treatment.fee === 'number' &&
        treatment.fee >= 0 &&
        treatment.fee < 1000000000
      );
    });
};
export class Treatment extends BaseComponent {
  inputTreatment = (index, name) => (v) => {
    const { handleChange, treatments } = this.props;
    const old = [...treatments];
    old[index][name] = v;
    handleChange('treatments', [...old]);
  };

  addTreatmentMore = () => {
    const { handleChange, treatments, defaultTreatments } = this.props;
    treatments.push(defaultTreatments());
    handleChange('treatments', [...treatments]);
  };

  delTreatmentMore = (delIds) => {
    const { handleChange, treatments } = this.props;
    handleChange('treatments', [...treatments.filter((item, i) => delIds.indexOf(i) === -1)]);
  };

  render() {
    const { invalid: mainInvalid, treatments, handleBlur, description, currency } = this.props;
    const invalid = (mainInvalid && mainInvalid['treatments']) || {};
    return (
      <>
        <Table
          className={'mc-doctor-treatment'}
          template={'3'}
          showPagination={false}
          data={treatments}
          columns={[
            {
              label: 'Treatments name',
              render: (treatment, i) => (
                <>
                  <TextField
                    template={5}
                    name={'treatment_name_' + i}
                    value={treatment.name || ''}
                    onChange={(n, v) => {
                      this.inputTreatment(i, 'name')(v);
                    }}
                    onBlur={handleBlur}
                  />
                  {invalid['treatment_name_' + i] && (
                    <p className='mc-form-invalid-text'>{invalid['treatment_name_' + i]}</p>
                  )}
                </>
              )
            },
            {
              label: 'Fees',
              cellStyles: {
                paddingLeft: remCss(10),
                paddingRight: remCss(10),
                maxWidth: remCss(200)
              },
              render: (treatment, i) => (
                <>
                  <TextField
                    template={5}
                    name={'treatment_fee_' + i}
                    value={treatment.fee || ''}
                    onChange={(n, v) => {
                      this.inputTreatment(i, 'fee')(v);
                    }}
                    type={'money'}
                    currency={currency}
                    onBlur={handleBlur}
                  />

                  {invalid['treatment_fee_' + i] && (
                    <p className='mc-form-invalid-text'>{invalid['treatment_fee_' + i]}</p>
                  )}
                </>
              )
            },
            {
              label: '',
              cellStyles: { maxWidth: 50, textAlign: 'end' },
              render: (treatment, i) => (
                <MCButton
                  type={'button'}
                  onClick={() => this.delTreatmentMore([i])}
                  iconname={BASE_ICONS.CLOSE}
                  width={48}
                  padding={7}
                  light
                  radius
                  secondary
                />
              )
            }
          ]}
        />
        {!!description && (
          <div className='mc-form-description' style={{ marginTop: -20 }}>
            {description}
          </div>
        )}
        <div className={'mc-flex'}>
          <MCButton
            iconname={BASE_ICONS.PLUS}
            onClick={this.addTreatmentMore}
            label={lang.t('Add more')}
            medium
            primary
            radius
            light
          />
        </div>
        {typeof invalid === 'string' && <p className='mc-form-invalid-text'>{invalid}</p>}
      </>
    );
  }
}
